import Home from './pages/Home';
import ProductList from './pages/ProductList';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Cart from './pages/Cart';
import Product from './pages/Product';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CtxProvider } from './context/AppContext';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Merchant from './pages/Merchant';

const customTheme = extendTheme({
  colors: {
    brand: {
      100: '#333333',
      200: '#ed2224',
      300: '#ef682f',
      400: '#005e8a',
      500: '#063f59',
    },
  },
});

const App = () => {
  const { pathname } = useLocation();
  return (
    <ChakraProvider theme={customTheme}>
      <CtxProvider>
        {pathname !== '/signup' && pathname !== '/signin' && (
          <>
            <Navbar />
          </>
        )}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<ProductList />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/product" element={<Product />} />
          <Route path="/merchant" element={<Merchant />} />
        </Routes>

        {pathname !== '/signup' && pathname !== '/signin' && <Footer />}
      </CtxProvider>
    </ChakraProvider>
  );
};

export default App;
